import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import get from 'lodash/get';

import BracketMatchMobile from '@views/BracketMatchMobile';
import { getResult, hasResults } from '@utils/match';

import './BracketMobile.css';

export const getWinner = (match) =>
  match && hasResults(match) ? get(getResult(match), 'winner.team') : noop();

export const isAsserted = (match) =>
  get(match, 'assertions', []).includes('champion');

export const defaultRoundNames = [
  'Octavos',
  'Cuartos',
  'Semifinales',
  '3° Puesto',
  'Final',
];

const BracketMobile = ({
  rounds,
  roundNames,
  selectableFromIndex = 0,
  teamGroupByCode,
}) => {
  const titles = roundNames ?? defaultRoundNames;
  return (
    <div className={`bracket-mobile`}>
      {(rounds || []).map((roundElements, i) => (
        <div
          key={i}
          className={`round-mobile round-${i} ${
            i >= selectableFromIndex ? 'round-selectable' : 'round-computed'
          }`}
        >
          <div className="round-title">{titles[i] ?? `Ronda ${i + 1}`}</div>
          {(roundElements || []).map((bracketGroup, i) => (
            <div className="round-bracket-group" key={i}>
              {(bracketGroup || []).map((match = {}, i) => (
                <BracketMatchMobile
                  key={match.mid || i}
                  {...match}
                  teamGroupByCode={teamGroupByCode}
                />
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

BracketMobile.displayName = 'BracketMobile';
BracketMobile.propTypes = {
  rounds: PropTypes.arrayOf(PropTypes.array),
  roundNames: PropTypes.arrayOf(PropTypes.string),
  selectableFromIndex: PropTypes.number,
  teamGroupByCode: PropTypes.object,
};
BracketMobile.defaultProps = {
  rounds: [],
  roundNames: null,
  selectableFromIndex: 0,
  teamGroupByCode: {},
};

export default BracketMobile;
